import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export function getCarouselImageURL(href, image, overwrite) {
  // Preferência: quando há uma imagem personalizada, tenta usar metadados se disponíveis
  if (image && overwrite) {
    // Caso 1: valor é string de caminho interno
    if (typeof image === 'string') {
      return `${flattenToAppURL(image)}/@@images/image/great`;
    }

    // Caso 2: valor é array com objeto
    if (Array.isArray(image)) {
      const item = image[0];
      if (item) {
        const base = flattenToAppURL(item['@id'] || href?.['@id'] || '');

        const dlFromImageScales =
          item?.image_scales?.image?.[0]?.scales?.great?.download;
        const dlFromImage = item?.image?.scales?.great?.download;

        if (dlFromImageScales) return `${base}/${dlFromImageScales}`;
        if (dlFromImage) return `${base}/${dlFromImage}`;
        if (item['@id']) return `${base}/@@images/image/great`;
      }
    }

    // Caso 3: valor é objeto (com metadados ou apenas @id)
    if (typeof image === 'object') {
      const base = flattenToAppURL(image['@id'] || href?.['@id'] || '');
      const dlFromImageScales =
        image?.image_scales?.image?.[0]?.scales?.great?.download;
      const dlFromImage = image?.image?.scales?.great?.download;

      if (dlFromImageScales) return `${base}/${dlFromImageScales}`;
      if (dlFromImage) return `${base}/${dlFromImage}`;
      if (image['@id']) return `${base}/@@images/image/great`;
    }
  }

  // Fallback: comportamento anterior baseado na fonte (href)
  if (href && href.image_field === 'image') {
    return `${href['@id']}/@@images/image/great`;
  }
  return `${href?.['@id']}/@@images/preview_image/great`;
}
